import React from 'react';
import DFEPost from './DFEPost.js';
import Pagination from '../Pagination.js';
import DFEForm from '../DFEForm.js';
import DFEFilters from '../DFEFilters.js';
import PostGrid from '../PostGrid.js';
import PostFields from '../PostFields.js';
import '../../scss/templates/dfe.scss';

export default (props) => {
	const data = props.data;
	const widgetModel = data.widgetModel;
	const posts = data.posts;
	const filters = data.filters;
	if ( !posts.length && !filters.length) {
		return null;
	}
	const classNames = [
		'cdc-cc-widget',
		`cdc-cc-widget--${widgetModel.columns}col`,
		'cdc-cc-widget-dfe',
	];
	if (widgetModel.hasForm) {
		classNames.push('cdc-cc-widget-dfe--hasform');
	}
	return (
		<div id={widgetModel.id} className={classNames.join(' ')}>
			<div className="dfe-content-section">
			{ data.allTotal > 10 ?
				<DFEFilters data={data} />
				: ''
			}
				<div className="dfe-content-posts-container">
					<div className="dfe-content-search-form">
						{ data.allTotal > 10 ?
							<DFEForm data={data} />
							: ''
						}
					</div>
					<div className="dfe-content-posts">
						{!posts.length && filters.length ? (
							<PostFields.noResults></PostFields.noResults>
						): (
							<PostGrid data={data} PostComponent={DFEPost}></PostGrid>
						)}
					</div>
				</div>
			</div>
			{widgetModel.pagination && data.allTotal > 10 ? <Pagination data={data}></Pagination> : ''}
		</div>
	);
};
